import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FileDeterminant } from "../../../models/file-determinant";
import { BooleanDeterminant } from "../../../models/boolean-determinant";
import { BotDeterminant } from "../../../models/bot-determinant";
import { ButtonDeterminant } from "../../../models/button-determinant";
import { FileUploadDeterminant } from "../../../models/file-upload-determinant";
import { GridComponentDeterminant } from "../../../models/grid-component-determinant";
import { ClassificationDeterminant } from "../../../models/classification-determinant";
import { CollectionPlaceDeterminant } from "../../../models/collection_place-determinant";
import { DateDeterminant } from "../../../models/date-determinant";
import { Determinant } from "../../../models/determinant";
import { DeterminantType } from "../../../models/determinant-type";
import { FieldType } from "../../../models/field-type";
import { GeneralOperatorType } from "../../../models/general-operator";
import { GridDeterminant } from "../../../models/grid-determinant";
import { LogicCondition } from "../../../models/jsonlogic/logic-condition";
import { Variable } from "../../../models/jsonlogic/variable";
import { MoneyDeterminant } from "../../../models/money-determinant";
import { NumericDeterminant } from "../../../models/numeric-determinant";
import { RegistrationDeterminant } from "../../../models/registration-determinant";
import { SelectBoxesDeterminant } from "../../../models/selectboxes-determinant";

import { SelectDeterminant } from "../../../models/select-determinant";
import { SelectOperatorType } from "../../../models/select-operator";
import { SubCatalogDeterminant } from "../../../models/sub-catalog-determinant";
import { TextDeterminant } from "../../../models/text-determinant";
import { TextOperatorType } from "../../../models/text-operator";
import { DeterminantControllerService } from "../../../services/registration-controller/determinant-controller.service";
import { FormControllerService } from "../../../services/form-controller/form-controller.service";
import { Store } from "../../../services/store.service";
import * as _ from "lodash";
import { map } from 'rxjs/operators';
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "determinant-list",
  templateUrl: "./determinant-list.html",
  providers: [
    FormControllerService,
    DeterminantControllerService,
  ],
})
export class DeterminantList implements OnInit, OnChanges {

  @Input() public prefix: string;
  @Input() public groupsLength: any = { value: "" };
  @Input() public determinantMapById: { [key: string]: string };

  @Output() public onAddModalOpened = new EventEmitter();
  @Output() public onEditModalOpened = new EventEmitter();
  @Output() public onAddModalClosed = new EventEmitter();
  public conditions: LogicCondition[] = [];
  public determinants: Determinant[];
  public allFields: any;
  public determinantsFilter: any = { name: "" };
  public connectedTo: string[] = [];
  public loading: boolean = true;
  @Input() public addDeterminantTo: (determinant: Determinant) => void;
  private lastModifiedDeterminantId: string;

  constructor(private determinantService: DeterminantControllerService,
    private route: ActivatedRoute,
    private formControllerService: FormControllerService,
    public store: Store,
    private toastr: ToastrService,
    private translate: TranslateService) {
  }

  public ngOnChanges(): void {
    this.createConnectedTo();
  }

  public ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params.serviceId) {
        this.store.state.common.serviceId = params.serviceId;
      }
    });
    this.loadDeterminants();
    this.store.state.common.addDeterminantModal.onClose((determinant: Determinant) => {
      if (determinant.deletedWhen) {
        if (this.determinantMapById[determinant.id]) {
          delete this.determinantMapById[determinant.id];
        }
      } else {
        this.determinantMapById[determinant.id] = determinant.name;
        this.lastModifiedDeterminantId = determinant.id;
      }
      this.closeAddModal();
    });
    this.store.state.common.editDeterminantModal.onClose(() => {
      this.loadDeterminants();
    });
    this.store.state.common.editDeterminantModal.onDeterminantHasChanged((changedDeterminant) => {
      this.lastModifiedDeterminantId = changedDeterminant.id;
      this.loadDeterminantsAndEmitConditionUpdatedEvent(changedDeterminant);
    });
  }

  public dropped(event: CdkDragDrop<LogicCondition[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  public openAddModal() {
    // this.store.state.common.addDeterminantModal.showModal();
    this.onAddModalOpened.emit();
    window.scrollTo(0, 0);
    this.store.state.common.determinantSection.topLayer = "edit";
  }

  public closeAddModal() {
    this.loadDeterminants();
    this.onAddModalClosed.emit();
  }

  public loadDeterminants() {
    if (this.store.state.common.serviceId) {
      const promises = [];
      promises.push(
        this.determinantService.getServiceDeterminants(this.store.state.common.serviceId).pipe(map(
          (data) => {
            return data;
          },
        )).toPromise(),
      );
      promises.push(
        this.formControllerService.getFlattenFormFields(this.store.state.common.serviceId, false).pipe(map(
          (data) => {
            return data;
          },
        )).toPromise(),
      );
      Promise.all<any[]>(promises).then((results: any[]) => {
        this.determinants = results[0];
        this.allFields = results[1];
        this.buildList(this.determinants);
      });
    }
  }

  public loadDeterminantsAndEmitConditionUpdatedEvent(changedDeterminant) {
    if (changedDeterminant.id) {
      if (changedDeterminant.deletedWhen) {
        if (this.determinantMapById[changedDeterminant.id]) {
          delete this.determinantMapById[changedDeterminant.id];
        }
      } else {
        this.determinantMapById[changedDeterminant.id] = changedDeterminant.name;
      }
    }
    if (this.store.state.common.serviceId) {
      this.determinantService.getServiceDeterminants(this.store.state.common.serviceId).subscribe(
        (data) => {
          this.determinants = data;

          this.buildList(this.determinants);
          this.store.state.common.determinants = this.determinants;
          this.store.state.common.conditions = this.conditions;
          const updatedLogicCondition = this.conditions.find((it) => it.items[0].id === changedDeterminant.id);
          this.store.state.common.determinantList.emitDeterminantHasChanged(updatedLogicCondition);
        });
    }
  }

  public findTypeFromKey(key) {
    return this.convertFieldTypeToDeterminantType(this.allFields.find((f) => {
      return f.key === key;
    })?.type);
  }

  public convertFieldTypeToDeterminantType(type: string): string {
    if (!type) { return null; }
    if (type.toLowerCase() === "editgrid" || type.toLowerCase() === "datagrid" || type.toUpperCase() === FieldType.GRID) {
      return FieldType.GRID.toLowerCase();
    } else if (type.toLowerCase() === "checkbox" || type === "boolean") {
      return FieldType.BOOLEAN.toLowerCase();
    } else if (type.toLowerCase() === "number" || type === "numeric") {
      return FieldType.NUMERIC.toLowerCase();
    } else if (type.toLowerCase() === "money") {
      return FieldType.MONEY.toLowerCase();
    } else if (type.toLowerCase() === "text" || type === "textfield" || type === "email") {
      return FieldType.TEXT.toLowerCase();
    } else if (type.toLowerCase() === "hidden") {
      return FieldType.HIDDEN.toLowerCase();
    } else if (type.toLowerCase() === "select") {
      return FieldType.CLASSIFICATION.toLowerCase();
    } else if (type.toLowerCase() === "radio") {
      return FieldType.RADIO.toLowerCase();
    } else if (type.toLowerCase() === "datetime" || type === "date") {
      return FieldType.DATE.toLowerCase();
    } else if (type.toLowerCase() === "classification") {
      return FieldType.CLASSIFICATION.toLowerCase();
    } else if (type.toLowerCase() === "grouping") {
      return FieldType.GROUPING.toLowerCase();
    } else if (type.toLowerCase() === "selectboxes") {
      return FieldType.SELECTBOXES.toLowerCase();
    } else if (type.toLowerCase() === "textarea") {
      return FieldType.TEXTAREA.toLowerCase();
    } else if (type.toUpperCase() === FieldType.SUB_CATALOG || type.toUpperCase() === FieldType.CLASSIFICATION || type.toUpperCase() === FieldType.GROUPING) {
      return type.toLowerCase();
    }
    return "";
  }

  public async checkFormfieldStatus(c, d) {
    if (c && d) {
      if (d.type.toLowerCase() === "file") {
        const op = d.operator?.toLowerCase();
        c.status = op === "equal" || op === "not_equal" || op === "is_valid" || op === "is_not_valid";
      } else {
        let hasTarget: any = null;
        if (d.type.toLowerCase() === "grid") {
          hasTarget = this.allFields.find((f) => d.rowDeterminant?.targetFormFieldKey === f.fullKey);
        } else {
          hasTarget = this.allFields.find((f) => d.targetFormFieldKey?.split(".")[0] === f.key);
        }
        const hasSource = d.sourceFormFieldKey ? this.allFields.find((f) => f.key === d.sourceFormFieldKey) : (d.selectValue ? true : false);
        c.status = (d.classificationField || (d.classificationFields?.length || d.classificationFieldIds?.length) || hasTarget) &&
          (this.checkDeterminantValue(d) || hasSource);
      }
    }
  }

  public editDeterminant(det) {
    det.loading = true;
    this.determinantService.getDeterminant(det.determinantId).subscribe((data) => {
      // this.store.state.common.editDeterminantModal.showModal(data);
      // Store.callUglyAngularRedraw();
      det.loading = false;
      this.onEditModalOpened.emit(data);
      window.scrollTo(0, 0);
      this.store.state.common.determinantSection.topLayer = "edit";
      this.store.state.common.determinantSection.determinant = data;
    });
  }

  public checkDeterminantValue(det) {
    switch (det.determinantType) {
      case DeterminantType.BOT.toString():
        return true;
      case DeterminantType.COLLECTION_PLACE.toString():
        return true;
      case DeterminantType.SERVICE.toString():
        return true;
      case DeterminantType.FORMFIELD.toString():
        return true;
      // return det.type === "boolean" ? true : (String(det.value) && String(det.value).length > 0 ? true : false);
      default:
        return true;
    }
  }

  public createConnectedTo() {

    // add if conditions for onChanges undefined status
    if (this.groupsLength) {
      if (this.groupsLength.value) {
        this.connectedTo = [];
        let groupCount;
        if (typeof this.groupsLength.value === "string") {
          groupCount = JSON.parse(this.groupsLength.value);
          if (!groupCount) { return; }
          groupCount = groupCount.length - 1;
        }
        else if (Array.isArray(this.groupsLength.value)) {
          groupCount = this.groupsLength.value.length - 1;
        }
        else if (typeof this.groupsLength.value === "object") {
          if (Array.isArray(this.groupsLength.value.groups)) {
            groupCount = this.groupsLength.value.groups.length - 1;
          }
        }
        let i = 0;
        while (i <= groupCount) {
          this.connectedTo.push(this.prefix + "-conditionsSelected-" + i);
          i++;
        }
      }
    }
  }

  public buildList(determinants: Determinant[]) {
    let generated = _.filter(determinants, (d) => d.generated === true || d.name.toLowerCase().indexOf("generated") >= 0);
    let analysts = _.filter(determinants, (d) => d.generated === false && d.name.toLowerCase().indexOf("generated") === -1);
    generated = _.sortBy(generated, [(determinant) => determinant.name.toLowerCase()], ["asc"]);
    analysts = _.sortBy(analysts, [(determinant) => determinant.name.toLowerCase()], ["asc"]);
    determinants = _.concat(analysts, generated);

    // Mark duplicate determinants
    this.markDuplicateDeterminants(determinants);

    this.conditions = this.createConditionsFrom(determinants);
    this.loading = false;
  }

  /**
   * Marks all determinants that have duplicates by adding an isDuplicate flag and collecting duplicate names.
   */
  private markDuplicateDeterminants(determinants: Determinant[]): void {
    determinants.forEach((determinant) => {
      const duplicates = this.findDuplicateDeterminants(determinant, determinants);
      determinant.isDuplicate = duplicates.length > 0;
      determinant.duplicateNames = duplicates.map((d) => d.name);

      if (determinant.isDuplicate && determinant.id === this.lastModifiedDeterminantId) {
        this.translate.get('Determinant {{name}} is a duplicate of {{duplicates}}', {
          name: determinant.name,
          duplicates: determinant.duplicateNames.join(', ')
        }).subscribe((res: string) => {
          this.toastr.warning(res);
        });
        this.lastModifiedDeterminantId = null;
      }
    });
  }

  /**
   * Finds all determinants that are duplicates of the given determinant.
   */
  private findDuplicateDeterminants(determinant: Determinant, allDeterminants: Determinant[]): Determinant[] {
    return allDeterminants.filter((existing) => {
      // Skip the same determinant
      if (existing.id === determinant.id) {
        return false;
      }

      // Skip if determinantType doesn't match
      if (existing.determinantType !== determinant.determinantType) {
        return false;
      }

      // Type-aware duplicate detection based on determinantType
      switch (determinant.determinantType) {
        case "FORMFIELD":
          return this.isFormfieldDuplicate(existing, determinant);
        case "BOT":
          return this.isBotDuplicate(existing, determinant);
        case "EVENT":
          return this.isEventDuplicate(existing, determinant);
        case "REGISTRATION":
          return this.isRegistrationDuplicate(existing, determinant);
        case "COLLECTION_PLACE":
          return this.isCollectionPlaceDuplicate(existing, determinant);
        default:
          return false;
      }
    });
  }

  private isFormfieldDuplicate(existing: Determinant, determinant: Determinant): boolean {
    if (existing.targetFormFieldKey !== determinant.targetFormFieldKey) {
      return false;
    }

    if ((existing as any).operator !== (determinant as any).operator) {
      return false;
    }

    const valueProperties = [
      "value",
      "sourceFormFieldKey",
      "classificationField",
      "gdbCatalogSelectedValue",
      "gdbCatalogFieldId",
      "gdbCatalogValue",
      "operatorStringValue",
      "textValue",
      "numericValue",
      "moneyValue",
      "booleanValue",
      "dateValue",
      "isCurrentDate",
      "selectValue",
      "classificationFields",
      "classificationFieldIds",
      "classificationGroup",
      "parentCatalogField",
      "subCatalogField",
      "buttonEventName",
      "buttonKey",
      "fileUploadEventName",
      "fileUploadKey",
      "gridEventName",
      "gridKey",
      "operator",
      "textOperator",
      "selectOperator",
      "classificationOperator",
      "determinantInsideGrid",
    ];

    const valueMatch = valueProperties.every((property) => {
      return _.isEqual(existing[property], determinant[property]);
    });

    if (!valueMatch) {
      return false;
    }

    // Check subject only if not inside grid
    if (!(existing as any).determinantInsideGrid) {
      if (!_.isEqual(existing.subject, determinant.subject)) {
        return false;
      }
    }

    // Check rowDeterminant specifically if it exists
    const existingRowDet = (existing as any).rowDeterminant;
    const determinantRowDet = (determinant as any).rowDeterminant;

    if (existingRowDet || determinantRowDet) {
      if (!existingRowDet || !determinantRowDet) {
        return false;
      }

      const rowDeterminantProperties = [
        'operator', 'textOperator', 'selectOperator', 'classificationOperator',
        'numericValue', 'moneyValue', 'textValue', 'booleanValue', 'dateValue', 'isCurrentDate', 'selectValue',
        'classificationField', 'classificationFields', 'classificationFieldIds', 'classificationGroup',
        'parentCatalogField', 'subCatalogField',
        'sourceFormFieldKey', 'targetFormFieldKey'
      ];

      return rowDeterminantProperties.every(prop => {
        return _.isEqual(existingRowDet[prop], determinantRowDet[prop]);
      });
    }

    return true;
  }

  private isBotDuplicate(existing: Determinant, determinant: Determinant): boolean {
    const existingBots = existing.bots || [];
    const determinantBots = determinant.bots || [];

    if (existingBots.length !== determinantBots.length) {
      return false;
    }

    const existingBotIds = existingBots.map((b) => b.id || b).sort();
    const determinantBotIds = determinantBots.map((b) => b.id || b).sort();

    return existingBotIds.every((id, index) => id === determinantBotIds[index]);
  }

  private isEventDuplicate(existing: Determinant, determinant: Determinant): boolean {
    return (
      existing.eventName === determinant.eventName &&
      existing.eventComponent === determinant.eventComponent
    );
  }

  private isRegistrationDuplicate(existing: Determinant, determinant: Determinant): boolean {
    return existing.registrationId === determinant.registrationId;
  }

  private isCollectionPlaceDuplicate(existing: Determinant, determinant: Determinant): boolean {
    return existing.registrationLocationKey === determinant.registrationLocationKey;
  }

  public createConditionsFrom(determinants: Determinant[]) {
    if (determinants) {
      return determinants.map((d) => {
        // create new JsonLogic condition from determinant
        const condition = new LogicCondition();
        condition.name = d.name;
        condition.determinantType = d.determinantType;
        condition.determinantId = d.id;
        condition.isDuplicate = d.isDuplicate;
        condition.duplicateNames = d.duplicateNames;
        const field = new Variable();
        field.id = d.id;
        field.targetKey = d.targetFormFieldKey;
        field.jsonPath = d.targetFormFieldJsonPath;
        field.gridFieldKey = d.targetGridFieldKey;
        field.gridFieldType = d.gridFieldType;
        field.determinantId = d.id;
        if (d.registrationKey) {
          field.fieldKey = d.registrationKey;
          field.type = FieldType.BOOLEAN;
        } else if (d.registrationLocationKey) {
          field.targetKey = d.registrationLocationKey;
          field.type = FieldType.BOOLEAN;
        } else if (d.type) {
          field.fieldKey = d.targetFormFieldKey;
          field.type = d.type;
        }
        // if comparing date fields
        if (d.sourceFormFieldKey && (d.type.toUpperCase() === FieldType.DATE)) {
          field.type = FieldType.TEXT;
        }
        // console.log(d, field);
        if (d.type.toUpperCase() === FieldType.GRID && !d.subject) {
          field.type = (d as GridDeterminant).rowDeterminant?.type;
          field.fieldKey = (d as GridDeterminant).rowDeterminant?.targetFormFieldKey;
          field.targetKey = (d as GridDeterminant).rowDeterminant?.targetFormFieldKey;
          field.id = (d as GridDeterminant).rowDeterminant?.id;
        }
        condition.items.push(field);
        if (d.generated) {
          condition.status = true;
        } else {
          switch (d.determinantType) {
            case DeterminantType.BOT.toString():
              condition.status = (d.bots.length > 0);
              break;
            case DeterminantType.COLLECTION_PLACE.toString():
              condition.status = true;
              break;
            case DeterminantType.SERVICE.toString():
              condition.status = true;
              break;
            case DeterminantType.FORMFIELD.toString():
              // Check for event-based determinants (button, fileUpload, gridComponent)
              if ((d as any).buttonEventName !== undefined) {
                const det = d as any;
                condition.status = (det.buttonKey && det.buttonKey.length > 0) && (det.buttonEventName && det.buttonEventName.length > 0);
              } else if ((d as any).fileUploadEventName !== undefined) {
                const det = d as any;
                condition.status = (det.fileUploadKey && det.fileUploadKey.length > 0) && (det.fileUploadEventName && det.fileUploadEventName.length > 0);
              } else if ((d as any).gridEventName !== undefined) {
                const det = d as any;
                condition.status = (det.gridKey && det.gridKey.length > 0) && (det.gridEventName && det.gridEventName.length > 0);
              } else if (d.eventName && d.eventComponent) {
                // Backwards compatibility: old-format event determinants used eventName and eventComponent
                // from base Determinant class (e.g., old "File is uploaded" determinants)
                condition.status = true;
              } else {
                condition.status = false;
                this.checkFormfieldStatus(condition, d);
              }
              break;
            case DeterminantType.REGISTRATION.toString():
              condition.status = (d.registrationId ? true : false);
              break;
            default:
              condition.status = true;
          }
        }

        // specify expected value
        if (d.determinantType === DeterminantType.BOT.toString()) {
          const det = d as BotDeterminant;
          condition.conditionType = GeneralOperatorType.EQUAL;
          condition.items.push(det.valid);
        } else if (d.determinantType === DeterminantType.REGISTRATION.toString()) {
          const det = d as RegistrationDeterminant;
          condition.conditionType = GeneralOperatorType.EQUAL;
          condition.items.push(det.selected);
        } else if (d.determinantType === DeterminantType.COLLECTION_PLACE.toString()) {
          const det = d as CollectionPlaceDeterminant;
          condition.conditionType = GeneralOperatorType.EQUAL;
          condition.items.push(det.selected);
        } else if (d.determinantType === DeterminantType.FORMFIELD.toString()) {
          // Check for event-based determinants (button, fileUpload, gridComponent)
          if ((d as any).buttonEventName !== undefined) {
            const det = d as ButtonDeterminant;
            condition.conditionType = GeneralOperatorType.EQUAL;
            condition.items.push(det.buttonEventName);
          } else if ((d as any).fileUploadEventName !== undefined) {
            const det = d as FileUploadDeterminant;
            condition.conditionType = GeneralOperatorType.EQUAL;
            condition.items.push(det.fileUploadEventName);
          } else if ((d as any).gridEventName !== undefined) {
            const det = d as GridComponentDeterminant;
            condition.conditionType = GeneralOperatorType.EQUAL;
            condition.items.push(det.gridEventName);
          } else {
            this.updateLogicWithFormFieldCondition(condition, d);
          }
          // BOOLEAN type determinant
        } else if (d.type.toUpperCase() === FieldType.BOOLEAN) {
          const det = d as BooleanDeterminant;
          condition.conditionType = GeneralOperatorType.EQUAL;
          // compared to other BOOLEAN field
          if (d.sourceFormFieldKey) {
            const sourceFormFieldKey = new Variable();
            sourceFormFieldKey.id = d.id;
            sourceFormFieldKey.fieldKey = d.sourceFormFieldKey;
            sourceFormFieldKey.type = FieldType.BOOLEAN;
            sourceFormFieldKey.determinantId = det.id;
            condition.items.push(sourceFormFieldKey);
          } else {
            condition.items.push(det.booleanValue);
          }
          // NUMERIC type determinant
        } else if (d.type.toUpperCase() === FieldType.NUMERIC) {
          const det = d as NumericDeterminant;
          condition.conditionType = det.operator as any;
          // compared to other NUMERIC field
          if (d.sourceFormFieldKey) {
            const sourceFormFieldKey = new Variable();
            sourceFormFieldKey.id = d.id;
            sourceFormFieldKey.fieldKey = d.sourceFormFieldKey;
            sourceFormFieldKey.type = FieldType.NUMERIC;
            sourceFormFieldKey.determinantId = det.id;
            condition.items.push(sourceFormFieldKey);
          } else {
            if (det.numericValue === 0 || det.numericValue) {
              condition.items.push(det.numericValue);
            } else {
              condition.items.push("");
            }
          }
          // MONEY type determinant
        } else if (d.type.toUpperCase() === FieldType.MONEY) {
          const det = d as MoneyDeterminant;
          condition.conditionType = det.operator;
          // compared to other MONEY field
          if (d.sourceFormFieldKey) {
            const sourceFormFieldKey = new Variable();
            sourceFormFieldKey.id = d.id;
            sourceFormFieldKey.fieldKey = d.sourceFormFieldKey;
            sourceFormFieldKey.type = FieldType.MONEY;
            sourceFormFieldKey.determinantId = det.id;
            condition.items.push(sourceFormFieldKey);
          } else {
            if (det.moneyValue === 0 || det.moneyValue) {
              condition.items.push(det.moneyValue);
            } else {
              condition.items.push("");
            }
          }
          // FILE DETERMINANT
        } else if (d.type.toUpperCase() === FieldType.FILE) {
          const det = d as unknown as FileDeterminant;
          if (det.operator === TextOperatorType.EQUAL) {
            condition.conditionType = GeneralOperatorType.EQUAL;
          } else {
            condition.conditionType = GeneralOperatorType.NOT_EQUAL;
          }
          // TEXT type determinant
        } else if (d.type.toUpperCase() === FieldType.TEXT) {
          const det = d as unknown as TextDeterminant;
          if (det.operator === TextOperatorType.EQUAL) {
            condition.conditionType = GeneralOperatorType.EQUAL;
          } else {
            condition.conditionType = GeneralOperatorType.NOT_EQUAL;
          }
          // compared to other TEXT field
          if (d.sourceFormFieldKey) {
            const sourceFormFieldKey = new Variable();
            sourceFormFieldKey.id = d.id;
            sourceFormFieldKey.fieldKey = d.sourceFormFieldKey;
            sourceFormFieldKey.type = FieldType.TEXT;
            sourceFormFieldKey.determinantId = det.id;
            condition.items.push(sourceFormFieldKey);
          } else {
            if (det.textValue) {
              condition.items.push(det.textValue);
            } else {
              condition.items.push("");
            }
          }
          // SELECTION/RADIO type determinant
        } else if ((d.type.toUpperCase() === FieldType.SELECTION) || (d.type.toUpperCase() === FieldType.RADIO)) {
          const det = d as unknown as SelectDeterminant;
          if (det.operator === SelectOperatorType.EQUAL) {
            condition.conditionType = GeneralOperatorType.EQUAL;
          } else {
            condition.conditionType = GeneralOperatorType.NOT_EQUAL;
          }
          // compared to other SELECTION field
          if (d.sourceFormFieldKey) {
            const sourceFormFieldKey = new Variable();
            sourceFormFieldKey.id = d.id;
            sourceFormFieldKey.fieldKey = d.sourceFormFieldKey;
            sourceFormFieldKey.type = FieldType.SELECTION;
            sourceFormFieldKey.determinantId = det.id;
            condition.items.push(sourceFormFieldKey);
          } else {
            if (det.selectValue) {
              condition.items.push(det.selectValue);
            } else {
              condition.items.push("");
            }
          }
        } else if ((d.type.toUpperCase() === FieldType.SELECTBOXES)) {
          const det = d as unknown as SelectBoxesDeterminant;
          if (det.operator === SelectOperatorType.EQUAL) {
            condition.conditionType = GeneralOperatorType.EQUAL;
          } else {
            condition.conditionType = GeneralOperatorType.NOT_EQUAL;
          }
          condition.items.push(det.booleanValue);
          // DATE type determinant
        } else if ((d.type.toUpperCase() === FieldType.DATE)) {
          const det = d as DateDeterminant;
          condition.conditionType = det.operator;
          if (d.sourceFormFieldKey) {
            const sourceFormFieldKey = new Variable();
            sourceFormFieldKey.id = d.id;
            sourceFormFieldKey.fieldKey = d.sourceFormFieldKey;
            sourceFormFieldKey.type = FieldType.TEXT;
            sourceFormFieldKey.determinantId = det.id;
            condition.items.push(sourceFormFieldKey);
          } else {
            if (!det.isCurrentDate) {
              condition.items.push(new Date(det.dateValue));
            } else {
              const dateTimeNow = new Variable();
              dateTimeNow.id = d.id + "_dateTimeNow";
              dateTimeNow.fieldKey = "dateTimeNow";
              dateTimeNow.type = FieldType.DATE;
              dateTimeNow.determinantId = det.id;
              condition.items.push(dateTimeNow);
            }
          }
        } else if ((d.type.toUpperCase() === FieldType.CLASSIFICATION)) {
          const det = d as unknown as ClassificationDeterminant;
          if (det.operator === SelectOperatorType.EQUAL) {
            condition.conditionType = GeneralOperatorType.EQUAL;
          } else if (det.operator === SelectOperatorType.IN) {
            condition.conditionType = GeneralOperatorType.IN;
          } else if (det.operator === SelectOperatorType.NOT_IN) {
            condition.conditionType = GeneralOperatorType.NOT_IN;
          } else {
            condition.conditionType = GeneralOperatorType.NOT_EQUAL;
          }
          if (det.classificationGroup) {
            condition.subject = det.subject;
            condition.items.push(det.classificationGroup);
          } else if (d.classificationField) {
            condition.items.push(d.classificationField);
          } else {
            if ((det.operator === SelectOperatorType.EQUAL || det.operator === SelectOperatorType.NOT_EQUAL) && ((det.classificationFields && det.classificationFields.length > 0) || det.sourceFormFieldKey)) {
              if (det.classificationField) {
                det.classificationField.determinantId = det.id;
                condition.items.push(det.classificationField);
              } else if (det.classificationFields && det.classificationFields.length > 0) {
                // first item is "true" value
                condition.items[0] = true;
                // second item is array of catalog values
                const multipleCatalogValue: any = {};
                multipleCatalogValue.type = "multipleCatalogValue";
                multipleCatalogValue.fieldKey = d.targetFormFieldKey;
                multipleCatalogValue.items = det.classificationFields;
                multipleCatalogValue.subject = det.subject;
                condition.items.push(multipleCatalogValue);
              } else if (det.sourceFormFieldKey && this.findTypeFromKey(det.sourceFormFieldKey)) {
                const sourceFormFieldKey = new Variable();
                sourceFormFieldKey.id = d.id;
                sourceFormFieldKey.fieldKey = det.sourceFormFieldKey;
                sourceFormFieldKey.type = this.findTypeFromKey(det.sourceFormFieldKey);
                sourceFormFieldKey.determinantId = det.id;
                condition.items.push(sourceFormFieldKey);
              } else {
                condition.items.push(null);
              }
            }
          }
        } else if (d.type.toUpperCase() === FieldType.SUB_CATALOG) {
          const det = d as unknown as SubCatalogDeterminant;
          if (det.operator === SelectOperatorType.EQUAL) {
            condition.conditionType = GeneralOperatorType.EQUAL;
          } else {
            condition.conditionType = GeneralOperatorType.NOT_EQUAL;
          }
          condition.items.push(det.subCatalogField);
        }
        return condition;
      });
    } else {
      return null;
    }
  }

  private updateLogicWithFormFieldCondition(condition: LogicCondition, d: Determinant): void {
    // console.log(condition, d);
    if (d.type.toUpperCase() === FieldType.BOOLEAN) {
      const det = d as BooleanDeterminant;
      condition.conditionType = GeneralOperatorType.EQUAL;
      // compared to other BOOLEAN field
      if (d.sourceFormFieldKey) {
        const sourceFormFieldKey = new Variable();
        sourceFormFieldKey.id = d.id;
        sourceFormFieldKey.fieldKey = d.sourceFormFieldKey;
        sourceFormFieldKey.type = FieldType.BOOLEAN;
        sourceFormFieldKey.determinantId = det.id;
        condition.items.push(sourceFormFieldKey);
      } else {
        condition.items.push(det.booleanValue);
      }
      // NUMERIC type determinant
    } else if (d.type.toUpperCase() === FieldType.NUMERIC) {
      const det = d as NumericDeterminant;
      condition.conditionType = det.operator as any;
      // compared to other NUMERIC field
      if (d.sourceFormFieldKey) {
        const sourceFormFieldKey = new Variable();
        sourceFormFieldKey.id = d.id;
        sourceFormFieldKey.fieldKey = d.sourceFormFieldKey;
        sourceFormFieldKey.type = FieldType.NUMERIC;
        sourceFormFieldKey.determinantId = det.id;
        condition.items.push(sourceFormFieldKey);
      } else {
        if (det.numericValue === 0 || det.numericValue) {
          condition.items.push(det.numericValue);
        } else {
          condition.items.push("");
        }
      }
      // MONEY type determinant
    } else if (d.type.toUpperCase() === FieldType.MONEY) {
      const det = d as MoneyDeterminant;
      condition.conditionType = det.operator;
      // compared to other MONEY field
      if (d.sourceFormFieldKey) {
        const sourceFormFieldKey = new Variable();
        sourceFormFieldKey.id = d.id;
        sourceFormFieldKey.fieldKey = d.sourceFormFieldKey;
        sourceFormFieldKey.type = FieldType.MONEY;
        sourceFormFieldKey.determinantId = det.id;
        condition.items.push(sourceFormFieldKey);
      } else {
        if (det.moneyValue === 0 || det.moneyValue) {
          condition.items.push(det.moneyValue);
        } else {
          condition.items.push("");
        }
      }
    } else if (d.type.toUpperCase() === FieldType.GRID) {
      if (d.subject) {
        const det = d as GridDeterminant;
        condition.subject = det.subject;
        if (det.rowDeterminant) {
          const rowCondition = new LogicCondition();
          rowCondition.name = det.rowDeterminant.name;
          rowCondition.determinantType = det.rowDeterminant.determinantType;
          rowCondition.determinantId = det.rowDeterminant.id;
          const field = new Variable();
          field.id = det.rowDeterminant.id;
          field.targetKey = det.rowDeterminant.targetFormFieldKey;
          field.fieldKey = det.rowDeterminant.sourceFormFieldKey;
          field.type = det.rowDeterminant.type;
          field.determinantId = det.id;
          rowCondition.items.push(field);
          this.updateLogicWithFormFieldCondition(rowCondition, det.rowDeterminant);
          condition.items.push(rowCondition);
        }
      } else {
        const det = d as GridDeterminant;
        if (det.rowDeterminant) {
          this.updateLogicWithFormFieldCondition(condition, det.rowDeterminant);
        }
      }
    } else if (d.type.toUpperCase() === FieldType.TEXT) {
      const det = d as unknown as TextDeterminant;
      if (det.operator === TextOperatorType.EQUAL) {
        condition.conditionType = GeneralOperatorType.EQUAL;
      } else {
        condition.conditionType = GeneralOperatorType.NOT_EQUAL;
      }
      // compared to other TEXT field
      if (d.sourceFormFieldKey) {
        const sourceFormFieldKey = new Variable();
        sourceFormFieldKey.id = d.id;
        sourceFormFieldKey.fieldKey = d.sourceFormFieldKey;
        sourceFormFieldKey.type = FieldType.TEXT;
        sourceFormFieldKey.determinantId = det.id;
        condition.items.push(sourceFormFieldKey);
      } else {
        if (det.textValue) {
          condition.items.push(det.textValue);
        } else {
          condition.items.push("");
        }
      }
      // SELECTION/RADIO type determinant
    } else if ((d.type.toUpperCase() === FieldType.SELECTION) || (d.type.toUpperCase() === FieldType.RADIO)) {
      const det = d as unknown as SelectDeterminant;
      if (det.operator === SelectOperatorType.EQUAL) {
        condition.conditionType = GeneralOperatorType.EQUAL;
      } else {
        condition.conditionType = GeneralOperatorType.NOT_EQUAL;
      }
      // compared to other SELECTION field
      if (d.sourceFormFieldKey) {
        const sourceFormFieldKey = new Variable();
        sourceFormFieldKey.id = d.id;
        sourceFormFieldKey.fieldKey = d.sourceFormFieldKey;
        sourceFormFieldKey.type = FieldType.SELECTION;
        sourceFormFieldKey.determinantId = det.id;
        condition.items.push(sourceFormFieldKey);
      } else {
        if (det.selectValue) {
          condition.items.push(det.selectValue);
        } else {
          condition.items.push("");
        }
      }
    } else if ((d.type.toUpperCase() === FieldType.SELECTBOXES)) {
      const det = d as unknown as SelectBoxesDeterminant;
      if (det.operator === SelectOperatorType.EQUAL) {
        condition.conditionType = GeneralOperatorType.EQUAL;
      } else {
        condition.conditionType = GeneralOperatorType.NOT_EQUAL;
      }
      condition.items.push(det.booleanValue);
      // DATE type determinant
    } else if ((d.type.toUpperCase() === FieldType.DATE)) {
      const det = d as DateDeterminant;
      condition.conditionType = det.operator;
      if (d.sourceFormFieldKey) {
        const sourceFormFieldKey = new Variable();
        sourceFormFieldKey.id = d.id;
        sourceFormFieldKey.fieldKey = d.sourceFormFieldKey;
        sourceFormFieldKey.type = FieldType.TEXT;
        sourceFormFieldKey.determinantId = det.id;
        condition.items.push(sourceFormFieldKey);
      } else {
        if (!det.isCurrentDate) {
          condition.items.push(new Date(det.dateValue));
        } else {
          const dateTimeNow = new Variable();
          dateTimeNow.id = d.id + "_dateTimeNow";
          dateTimeNow.fieldKey = "dateTimeNow";
          dateTimeNow.type = FieldType.DATE;
          dateTimeNow.determinantId = det.id;
          condition.items.push(dateTimeNow);
        }
      }
    } else if ((d.type.toUpperCase() === FieldType.CLASSIFICATION)) {
      const det = d as unknown as ClassificationDeterminant;
      if (det.operator === SelectOperatorType.EQUAL) {
        condition.conditionType = GeneralOperatorType.EQUAL;
      } else if (det.operator === SelectOperatorType.IN) {
        condition.conditionType = GeneralOperatorType.IN;
      } else if (det.operator === SelectOperatorType.NOT_IN) {
        condition.conditionType = GeneralOperatorType.NOT_IN;
      } else {
        condition.conditionType = GeneralOperatorType.NOT_EQUAL;
      }
      if (det.classificationGroup) {
        condition.subject = det.subject;
        condition.items.push(det.classificationGroup);
      } else if (d.classificationField) {
        d.classificationField.determinantId = det.id;
        condition.items.push(d.classificationField);
      } else {
        if ((det.operator === SelectOperatorType.EQUAL || det.operator === SelectOperatorType.NOT_EQUAL) && det.classificationFields && det.classificationFields.length > 0) {
          if (det.classificationField) {
            det.classificationField.determinantId = det.id;
            condition.items.push(det.classificationField);
          } else if (det.classificationFields && det.classificationFields.length > 0) {
            // first item is "true" value
            condition.items[0] = true;
            // second item is array of catalog values
            const multipleCatalogValue: any = {};
            multipleCatalogValue.type = "multipleCatalogValue";
            multipleCatalogValue.fieldKey = d.targetFormFieldKey;
            multipleCatalogValue.items = det.classificationFields;
            multipleCatalogValue.subject = det.subject;
            condition.items.push(multipleCatalogValue);
          } else {
            condition.items.push(null);
          }
        }
      }
    } else if (d.type.toUpperCase() === FieldType.SUB_CATALOG) {
      const det = d as unknown as SubCatalogDeterminant;
      if (det.operator === SelectOperatorType.EQUAL) {
        condition.conditionType = GeneralOperatorType.EQUAL;
      } else {
        condition.conditionType = GeneralOperatorType.NOT_EQUAL;
      }
      condition.items.push(det.subCatalogField);
    }
  }

}
